<template>
  <div class="inner">
    <h5 class="mt-3 font-weight-bold">เกรด</h5>
    {{ exam._globalCriteria?.isError }}
    <div
      v-for="_globalCriteria in exam._globalCriteria"
      :key="_globalCriteria.index"
      class="grading-bg"
      v-bind:class="{ isError: _globalCriteria.isError }"
    >
      <ul>
        <li
          id="abc"
          class="button-grading"
          :class="_globalCriteria.isCollapse ? 'not-collapsed' : 'collapsed'"
          :aria-expanded="_globalCriteria.isCollapse ? 'true' : 'false'"
          :aria-controls="_globalCriteria.grade"
        >
          <div
            class="text-left font-weight-bold ml-2"
            @click="TOGGLE_COLLAPSE(_globalCriteria)"
          >
            {{ _globalCriteria.grade }} {{ _globalCriteria.grade === 'F' ? '(ไม่ผ่าน)' : '' }} | 
            {{ _globalCriteria.lowerBoundRange }} -
            {{ _globalCriteria.upperBoundRange }} เปอร์เซ็นต์
          </div>
          <div class="text-right">
            <b-button
              v-if="exam._globalCriteria.length > 2 && _globalCriteria.grade !== 'F'"
              variant="danger"
              size="sm"
              @click="deleteGrading(_globalCriteria.index)"
              :disabled="hasValidationErrors"
            >
              <b-icon icon="trash"></b-icon
            ></b-button>
            <span class="when-opened" style="margin-left: 24px;">
              <i
                class="fa fa-chevron-down"
                aria-hidden="true"
                @click="TOGGLE_COLLAPSE(_globalCriteria)"
              ></i
            ></span>
          </div>
          <b-collapse
            :id="_globalCriteria.grade"
            v-model="_globalCriteria.isCollapse"
            class="font-weight-bold"
          >
            <div class="my-3 ml-2">
              ช่วงของเปอร์เซ็นต์
              <b-form inline class="mt-2">
                <div class="input-group mr-3" style="width: 150px;">
                    <b-form-input
                        type="text"
                        class="grading-input-bg"
                        v-model="_globalCriteria.lowerBoundRange"
                        @keyup="updateGrading()"
                        :formatter="formatterNumber"
                        :disabled="_globalCriteria.grade === 'F'"
                      ></b-form-input>
                    <div class="input-group-prepend">
                        <span class="input-group-text" style="border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                            %
                        </span>
                    </div>
                </div>
                ถึง
                <div class="input-group mx-3 " style="width: 150px;">
                    <b-form-input
                      type="text"
                      class="grading-input-bg"
                      v-model="_globalCriteria.upperBoundRange"
                      @keyup="updateGrading()"
                      :formatter="formatterNumber"
                      :disabled="isFirstGrade(_globalCriteria)"
                    ></b-form-input>
                    <div class="input-group-prepend">
                        <span class="input-group-text" style="border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                            %
                        </span>
                    </div>
                </div>
              </b-form>
            </div>
            <div class="my-3 ml-2">
              <label>ใส่คำอธิบายสำหรับเกรดนี้</label><br />
              <div cols="12" sm="6" lg="3" v-if="_globalCriteria.message">
                <label style="color: #aba9a7; margin-top: 20px">{{
                _globalCriteria.message,
                }}</label>
                <b-button
                  @click="modalPreviewMessage(_globalCriteria)"
                  class="create-new-link-button ml-2"
                  variant="outline-primary "
                  size="sm"
                >
                  preview
                </b-button>

                <b-button
                  @click="modalMessage(_globalCriteria)"
                  class="create-new-link-button ml-2"
                  variant="primary"
                  size="sm"
                  :disabled="_globalCriteria.isError"
                >
                  <b-icon icon="pencil-square" size="sm"></b-icon>
                  แก้ไข
                </b-button>
              </div>
              <div cols="12" sm="6" lg="3" v-else>
                <b-button
                  @click="modalMessage(_globalCriteria)"
                  class="create-new-link-button mt-2"
                  variant="primary"
                  size="sm"
                >
                  เพิ่มคำอธิบาย
                </b-button>
              </div>
            </div>
          </b-collapse>
        </li>
      </ul>
    </div>
    <div cols="12" sm="6" lg="3" v-if="!isCourseRule">
      <b-button
        @click="addNewGrading()"
        class="create-new-link-button mt-2"
        variant="primary"
        size="sm"
        :disabled="isCourseRule || hasValidationErrors"
      >
        <b-icon size="lg" icon="plus"></b-icon>
        เพิ่มเกรด
      </b-button>
    </div>
    <!-- section criteria -->
    <SectionCriteria 
      v-if="comId == 473"
      v-model="sectionCriteria"
      :disabled="false"
    />

    <b-modal
      :title="titleModal"
      size="xl"
      centered
      :hide-footer="true"
      class="mt-5"
      ref="modal-description"
      v-model="addStatusMessage"
    >
      <div>
        <ModelAddMessage
          :globalCriteria="globalCriteria"
          @hideModal="hideModal($event)"
          @onSave="onUpdateMessage($event)"
        />
      </div>
    </b-modal>

    <b-modal
      v-model="ModalPreviewChoices"
      title="Preview"
      size="lg"
      :hide-footer="true"
      ref="modal-preview"
    >
      <div>
        <Markdown :message="previewMessage" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ModelAddMessage from "../modal/ModelAddMessage.vue";
import Markdown from "@/components/shared/Markdown.vue";
import SectionCriteria from "@/components/shared/SectionCriteria.vue";
export default {
  props: {
    gradeTitle: String,
    lowerRange: Number,
    upperRange: Number,
  },
  data() {
    return {
      comId: JSON.parse(localStorage.getItem("ComId")),
      token: localStorage.getItem("token"),
      nextGrade: null,
      addStatusMessage: false,
      ModalPreviewChoices: false,
      titleModal: "",
      globalCriteria: [],
      previewMessage: "",
      sectionCriteria: false,
      isInitialMount: true,
      ArrayGrade: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ]
    };
  },

  async mounted() {
    this.sectionCriteria = this.exam?._options?.sectionCriteria ?? false;
    this.$nextTick(() => {
      this.isInitialMount = false;
    });
  },
  computed: {
    ...mapGetters("ExamBuilder", ["exam"]),
    ...mapGetters("CourseManagement", ["examModuleAndCourseAndLectures"]),
    ...mapGetters("CourseCompleteRule", ["courseCompleteRule"]),
    isCourseRule() {
      if (!this.exam._globalCriteria) return false;
      const grades = this.exam._globalCriteria.map(item => item.grade);
      return grades.length === 2 && 
             grades.includes('P') && 
             grades.includes('F');
    },
    hasValidationErrors() {
      if (!this.exam._globalCriteria) return false;
      return this.exam._globalCriteria.some(criteria => criteria.isError);
    }
  },
  components: {
    ModelAddMessage,
    Markdown,
    SectionCriteria,
  },
  methods: {
    formatter(gradeTitle) {
      const upperGrade = gradeTitle.toUpperCase();
      return upperGrade === 'F' ? '' : upperGrade;
    },
    formatterNumber(score) {
      if (!!score && Math.abs(score) >= 0) {
        return Math.abs(score);
      } else {
        return null;
      }
    },
    hideModal() {
      this.$refs["modal-description"].hide();
    },
    ...mapActions("ExamBuilder", [
      "updateExamInfo",
      "addglobalCriteria",
      "deleteglobalCriteria",
      "updateGlobalCriteria",
      "findExamsbyId",
      "updateOptions",
      "updateExamSectionCriteria"
    ]),
    ...mapActions("CourseCompleteRule", ["fetchCourseCompleteRules", "updateCourseExamRules"]),
    ...mapActions("CourseManagement", ["getCourseAndModuleByExamId"]),
    ...mapMutations("ExamBuilder", ["TOGGLE_COLLAPSE"]),
    async addNewGrading() {
      let Grade = [];

      const indexGrade = Math.max.apply(
        Math,
        this.exam._globalCriteria.map((globalCriteria) => globalCriteria.index)
      );

      for (let i = 2; i <= this.exam._globalCriteria.length; i++) {
        for (let j = 0; j <= this.ArrayGrade.length; j++) {
          if (
            this.exam._globalCriteria[this.exam._globalCriteria.length - i]
              .grade === this.ArrayGrade[j]
          ) {
            Grade.push(this.ArrayGrade[j + 1]);
          }
        }
        if (Grade.length > 0) break;
      }
      
      if (Grade.length === 0) {
          Grade.push('A')
      }

      let requestUpdate = {
        body: {
          lowerBoundRange:
            Math.floor(
              this.exam._globalCriteria[this.exam._globalCriteria.length - 1]
                .upperBoundRange / 2
            ) + 1,
          upperBoundRange: this.exam._globalCriteria[
            this.exam._globalCriteria.length - 1
          ].upperBoundRange,
          grade: Grade,
          message: this.exam._globalCriteria[
            this.exam._globalCriteria.length - 1
          ].message,
        },
        index: this.exam._globalCriteria[this.exam._globalCriteria.length - 1]
          .index,
        id: this.exam.id,
        token: this.token,
        checkUpdateOfDelete: false,
      };
      await this.updateGlobalCriteria(requestUpdate);

      let request = {
        body: {
          lowerBoundRange: 0,
          upperBoundRange: Math.floor(
            this.exam._globalCriteria[this.exam._globalCriteria.length - 1]
              .upperBoundRange / 2
          ),
          grade: "F",
          message: null,
          index: indexGrade + 1,
        },
        id: this.exam.id,
        token: this.token,
      };
      await this.addglobalCriteria(request);

      this.fetch();
    },
    async deleteGrading(gradeIndex) {
      let deletedGrade = null;
      
      for (let i = 0; i < this.exam._globalCriteria.length; i++) {
        if (this.exam._globalCriteria[i].index === gradeIndex) {
          deletedGrade = this.exam._globalCriteria[i];
          break;
        }
      }

      if (!deletedGrade) return;
      
      const sortedCriteria = [...this.exam._globalCriteria].sort((a, b) => 
        Number(b.upperBoundRange) - Number(a.upperBoundRange)
      );
      
      const deletedSortedPosition = sortedCriteria.findIndex(item => item.index === gradeIndex);
      
      const gradesToShift = [];
      for (let i = deletedSortedPosition + 1; i < sortedCriteria.length; i++) {
        gradesToShift.push(sortedCriteria[i]);
      }
      
      await this.shiftGradesUp(gradesToShift, deletedGrade);
      
      let requestDelete = {
        id: this.exam.id,
        token: this.token,
        index: gradeIndex,
      };
      await this.deleteglobalCriteria(requestDelete);
      
      setTimeout(() => {
        this.updateGrading();
      }, 200);
    },

    async shiftGradesUp(gradesToShift, deletedGrade) {
      for (let i = 0; i < gradesToShift.length; i++) {
        const gradeToShift = gradesToShift[i];
        const currentGradeIndex = this.ArrayGrade.indexOf(gradeToShift.grade);
        if (currentGradeIndex > 0) {
          // Shift grade up (e.g., D → C, E → D, F → E)
          const newGrade = this.ArrayGrade[currentGradeIndex - 1];
          
          const actualIndex = this.exam._globalCriteria.findIndex(item => item.index === gradeToShift.index);
          
          if (actualIndex !== -1) {
            // Only the first grade (immediately next to deleted) uses deleted grade's upper bound
            const useDeletedUpperBound = i === 0;
            
            let request = {
              body: {
                lowerBoundRange: this.exam._globalCriteria[actualIndex].lowerBoundRange,
                upperBoundRange: useDeletedUpperBound ? deletedGrade.upperBoundRange : this.exam._globalCriteria[actualIndex].upperBoundRange,
                grade: newGrade, // Shifted grade
                message: this.exam._globalCriteria[actualIndex].message,
              },
              index: this.exam._globalCriteria[actualIndex].index,
              id: this.exam.id,
              token: this.token,
              arrayindex: actualIndex,
              checkUpdateOfDelete: true,
            };
            await this.updateGlobalCriteria(request);
          }
        }
      }
    },

    modalPreviewMessage(_globalCriteria) {
      this.ModalPreviewChoices = true;
      this.previewMessage = _globalCriteria.message;
    },

    modalMessage(_globalCriteria) {
      if (!_globalCriteria.message) {
        this.titleModal = "เพิ่มคำอธิบาย";
      } else {
        this.titleModal = "แก้ไขคำอธิบาย";
      }
      this.addStatusMessage = true;
      this.globalCriteria = _globalCriteria;
    },
    fetch() {
      this.findExamsbyId(this.exam.id);
    },
    async onUpdateMessage(textMessage) {
      let request = {
        body: {
          lowerBoundRange: textMessage.data.lowerBoundRange,
          upperBoundRange: textMessage.data.upperBoundRange,
          grade: textMessage.data.grade,
          message: textMessage.message,
        },
        index: textMessage.data.index,
        id: this.exam.id,
        token: this.token,
        checkUpdateOfDelete: false,
      };
      await this.updateGlobalCriteria(request);
      this.fetch();
    },
    validateLowerCriteria(value, index) {
      const min = Number(this.exam._globalCriteria[index + 1].upperBoundRange);
      if (Number(value) <= min) {
        this.exam._globalCriteria[index].lowerBoundRange = min + 1;
        // event.preventDefault();
        return false;
      }
    },
    validateUpperCriteria() {},

    async updateGradeCriterias() {
      const grades = this.exam._globalCriteria.map(item => item.grade);
      const isCourseRule = grades.length === 2 && 
                        grades.includes('P') && 
                        grades.includes('F');
      
      if (isCourseRule) {
        await this.getCourseAndModuleByExamId(this.exam.id);
        const courseId = this.examModuleAndCourseAndLectures[0].courseId;

        await this.fetchCourseCompleteRules(courseId).then(() => {});
        
        const passGrade = this.exam._globalCriteria.find(criteria => criteria.grade === 'P');
        const passResultPercent = passGrade ? passGrade.lowerBoundRange : 60;
        
        await this.updateCourseExamRules({
          examId: this.exam.id,
          examResultPercent: passResultPercent,
          courseId: courseId,
          isUseExamRule: true,
          examRule: {
            examId: this.exam.id,
            examResultPercent: passResultPercent,
          },
        });
      }
      
      for (let i = 0; i <= this.exam._globalCriteria.length - 1; i++) {
        let request = {
          body: {
            lowerBoundRange: this.exam._globalCriteria[i].lowerBoundRange,
            upperBoundRange: this.exam._globalCriteria[i].upperBoundRange,
            grade: this.exam._globalCriteria[i].grade,
            message: this.exam._globalCriteria[i].message,
          },
          index: this.exam._globalCriteria[i].index,
          id: this.exam.id,
          token: this.token,
          arrayindex: i,
        };
        await this.updateGlobalCriteria(request);
      }
    },
    updateGrading() {
      this.exam._globalCriteria.every((item, index) => {
        // Check if grade is empty and mark as error
        if (item.grade === '') {
          this.exam._globalCriteria[index].isError = true;
          return false;
        }
        
        //first criteria
        if (index === 0) {
          if (Number(item.upperBoundRange) === 100) {
            this.exam._globalCriteria[index].isError = false;
            return true;
          } else if (Number(item.upperBoundRange) > 100) {
            this.exam._globalCriteria[index].isError = true;
            return false;
          } else if (Number(this.exam._globalCriteria[index].lowerBoundRange)) {
            this.exam._globalCriteria[index].isError = true;
            return false;
          }
        }
        //last criteria
        else if (index === this.exam._globalCriteria.length - 1) {
          if (
            Number(item.upperBoundRange) + 1 !==
            Number(this.exam._globalCriteria[index - 1].lowerBoundRange)
          ) {
            this.exam._globalCriteria[index - 1].isError = true;
            this.exam._globalCriteria[index].isError = true;
            return false;
          }
          if (Number(this.exam._globalCriteria[index].lowerBoundRange) !== 0) {
            this.exam._globalCriteria[index].isError = true;
            return false;
          } else {
            let arraycheckgrade = [],
              booleancheckgrade = false;
            for (let i = 0; i < this.exam._globalCriteria.length; i++) {
              arraycheckgrade.push(this.exam._globalCriteria[i].grade);
            }

            for (let j = 0; j < arraycheckgrade.length; j++) {
              for (let k = arraycheckgrade.length - 1; k > j; k--) {
                if (arraycheckgrade[j] === arraycheckgrade[k]) {
                  this.exam._globalCriteria[j].isError = true;
                  this.exam._globalCriteria[k].isError = true;
                  return false;
                } else {
                  this.exam._globalCriteria[j].isError = false;
                  this.exam._globalCriteria[k].isError = false;
                  booleancheckgrade = true;
                }
              }
            }
            if (booleancheckgrade) {
              this.updateGradeCriterias();
            }
            return true;
          }
        }
        //other
        else if (
          Number(item.upperBoundRange) + 1 ===
          Number(this.exam._globalCriteria[index - 1].lowerBoundRange)
        ) {
          this.exam._globalCriteria[index].isError = false;
          return true;
        } else {
          //else condition
          this.exam._globalCriteria[index - 1].isError = true;
          this.exam._globalCriteria[index].isError = true;
          return false;
        }
      });
    },
    isFirstGrade(criteria) {
      // Find the grade with the highest upper bound (first grade)
      if (!this.exam._globalCriteria || this.exam._globalCriteria.length === 0) {
        return false;
      }
      
      const sortedByUpperBound = [...this.exam._globalCriteria].sort((a, b) => 
        Number(b.upperBoundRange) - Number(a.upperBoundRange)
      );
      
      return sortedByUpperBound[0] === criteria;
    }
  },
};
</script>

<style scoped>
.not-collapsed .when-opened i {
  /* display: none; */
  transform: rotate(180deg);
  cursor: pointer;
}

.when-opened {
  padding: 2px 10px;
  cursor: pointer;
}

.b-collapse-grading {
  cursor: pointer;
}

.create-new-link-button {
  padding: 8px 25px;
}

.grading-bg {
  background-color: #f0f0f0;
  list-style: none;
  padding: 15px 15px;
  border-radius: 10px;
  margin: 10px 0;
  cursor: pointer;
  /* min-height: 100vh; */
}

.grading-input-bg {
  background-color: #fff !important;
}

.grading-input-bg:disabled {
  background-color: #f0f0f0 !important;
  color: #6c757d !important;
}

input[type="text"] {
  background-color: #f0f0f0;
}

input[type="text"]:disabled {
  cursor: not-allowed;
}

.button-grading {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 100px;
  justify-content: left;
  align-items: center;
}
.isError {
  border: 2px solid red !important;
}

.passing-percentage-input {
  background-color: #fff !important;
}
</style>
